import React, { useContext, useEffect, useRef, useState } from 'react';
import { tokenContext } from '../TokenContext';
import { useHistory } from 'react-router-dom';
import { PagoExitoso } from './PagoExitoso';
import { usePayments } from '../../hooks/usePayments';
import './Pago.css';
import { Facebook } from 'react-spinners-css';
import { PagoCancelado } from './PagoCancelado';
import { ErrorPago } from './ErrorPago';
import { useServices } from '../../hooks/useServices';
import { PagoExitosoExistente } from './PagoExitosoExistente';
import { useEventos } from '../../hooks/useEventos';

export const Payment = () => {


	const pago = useRef();
	const history = useHistory();


	const { pay } = useContext(tokenContext);

	const { guardaDataPay } = useServices();

	const [consultaPayId, setConsultaPayId] = useState({
		loadid: false,
		respuestaPayId: null
	});

	const { loadid, respuestaPayId } = consultaPayId;

const { regresaPago } = useEventos();
	const respuestaJson = pay;

	console.log('LIC response: ', respuestaJson);


	const checkString = (objetoValidar) => {
		let respuestaJson2;
		if (typeof objetoValidar === 'string' || objetoValidar instanceof String)
			// it's a string
			respuestaJson2 = JSON.parse(objetoValidar);
		else {
			respuestaJson2 = objetoValidar;
		}

		return respuestaJson2
	}


	useEffect(() => {


		async function fetchInitialData() {
			if (respuestaJson) {
				const respuestaJson2 = await checkString(respuestaJson);
				//console.log('respuestaJson2: ', respuestaJson2);
				if (respuestaJson2.paymentSelfServiceResponse) {
					const requestBitacora = {
						"transactionExtId": parseInt(respuestaJson2.paymentSelfServiceResponse.transactionExtId),
						"statusId": respuestaJson2.paymentSelfServiceResponse.statusId,
						"code": respuestaJson2.paymentSelfServiceResponse.message.code + "",
						"messageCode": respuestaJson2.paymentSelfServiceResponse.message.description,
						"authorizationCode": respuestaJson2.paymentSelfServiceResponse.authorizationCode,
						"approvalCode": respuestaJson2.paymentSelfServiceResponse.approvalCode,
						"transactionId": respuestaJson2.paymentSelfServiceResponse.transactionId + ""
					}
//console.log('request guardar bitacora: ', requestBitacora);
           regresaPago(requestBitacora.messageCode);
					const response = await guardaDataPay(requestBitacora);
					if (response) {
					//	console.log('response bitacora update:', response);
						if (respuestaJson2.paymentSelfServiceResponse.message.code != 1) {
							const error = {
								code: respuestaJson2.paymentSelfServiceResponse.message.code,
								description: respuestaJson2.paymentSelfServiceResponse.message.description
							}
							console.log('error de sistema: ', respuestaJson2.paymentSelfServiceResponse.message);
							pago.current = <ErrorPago data1={response} errore={error} />;
							setConsultaPayId({
								loadid: true,
								respuestaPayId: response
							});

						} else {
							const detalle = respuestaJson2.paymentSelfServiceResponse.message.detail;
							switch (response.status_id) {
								case 3:
									if (detalle != null && detalle != "") {
										pago.current = <PagoExitosoExistente {...response} />;
									} else {
										pago.current = <PagoExitoso {...response} />;

									}
									break;
								case 2:
									pago.current = <PagoCancelado {...response} />;
									break;
								case 4:
									pago.current = <ErrorPago {...response} />;
									break;
								default:
									pago.current = <ErrorPago {...response} />;
									console.log('statusId desconocido o nulo');
									break;
							}
							setConsultaPayId({
								loadid: true,
								respuestaPayId: response
							});
						}


					} else {
						console.log('error al obtener Data ID: ', response)
						setConsultaPayId({
							loadid: true,
							respuestaPayId: response
						});
					}
				} else {
					console.log('error de sistema de pago');
					history.push("/Error");
				}


			} else {
				history.push("/");

			}


		}
		fetchInitialData();

	}, [pay]);


	


	// code -Codigos error y su descripcion:
	// 400	 “Faltan parámetros requeridos.”
	// 9001	Datos inválidos. El parámetro {parámetro} contiene datos inválidos.
	// 9003	Las reglas no se aplicaron correctamente.
	// 9302	No se encontró información.


	return (
		<div className="contenedorPromociones">
			{loadid
				? <>
					<div className="logoUnefon animate__animated animate__slideInLeft"></div>
					{pago.current}

                    
                </>  
                : <div className="spinner"><Facebook color="#594498"/></div>
            }
    </div>
    
  )
}
